module.exports = __webpack_public_path__ + "img/creative-commons-zero.19fd8bd5.svg";